import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create root and render app
const root = ReactDOM.createRoot(rootElement);
root.render(<App />); 